import React from "react";
import s from "./ContactsFooter.module.css"
import ReactTooltip from 'react-tooltip';
import {VERSION} from "../../../ConfigProject/configProject";

const ContactsFooter = () => {
    return (
        <div className={s.footerContactsWrap}>

            <a href="https://xcircular.com/" data-tip={`React-tooltip`} target="_blank" rel="noopener noreferrer" className={s.logo}>xCircular</a>
            {/*<p className={s.logo} data-tip={`React-tooltip`}>xCircular</p>*/}

            <ReactTooltip
                place="top" effect="float"
                // aria-haspopup='true'
                // id='version'
                offset={{'top': 10, 'left': 5}}
                // role='example'
                // // delayShow={1000}
                className={`${s.tooltip} tooltip_custom`}
            >
                <div>
                    {`גירסת תוכנה ${VERSION}`}
                </div>

            </ReactTooltip>

            <a href="https://xcircular.com/" target="_blank" rel="noopener noreferrer">www.xcircular.com</a>
            <a href="mailto: support@xcircular.com" target="_top">support@xcircular.com</a>
        </div>
    )
};

export default ContactsFooter;